import React, { useEffect, useRef } from 'react';
import SearchIcon from '@mui/icons-material//Search';
import { IconTextField } from 'components/IconTextField';
import { FirmFilterProps } from './FirmFilter.props';

const FirmFilter = ({ setFilterSearch, isCompanyFilter = false }: FirmFilterProps) => {
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (inputRef.current) {
        inputRef.current.focus();
      }
    }, 100);

    return () => {
      clearTimeout(timeout);
    };
  }, []);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    e.stopPropagation();
    const text = e.target.value?.toLowerCase() || '';
    setFilterSearch(text);
  };

  return (
    <div>
      <IconTextField
        inputRef={inputRef}
        id="company-filter"
        onChange={e => {
          e.stopPropagation();
          handleChange(e);
        }}
        placeholder={isCompanyFilter ? 'Find a Company' : 'Find a Firm'}
        type="text"
        fullWidth
        variant="outlined"
        autoComplete="off"
        size="small"
        iconEnd={<SearchIcon />}
        onClick={e => {
          e.stopPropagation();
        }}
      />
    </div>
  );
};

export default FirmFilter;
